module.exports = __webpack_public_path__ + "img/headshot-3.9cbdf6af.png";